import { Box, Button, Checkbox } from '@shopify/polaris';
import React, { useState } from 'react';
import { reqGetOrderNewShopifyDetailSelect } from '../../../../api';
import ShopifyModal from "../../../../components/ShopifyModal";

const PaymentCheckModal = ({
    isItemCheck,
    setIsItemCheck,
    setSearchLoading,
    listData,
    setListData,
    toastFun,
    getPageData
})=> {
    const [isRemind,setIsRemind] = useState(false);
    const [loading,setLoading] = useState(false);
    const handleOff = ()=>{
        setIsRemind(false)
        setIsItemCheck((prev)=>({
            ...prev,
            open:false
        }))
    }
    const handleViewDetail = () => {
        
          let sendMsg = `Hello, I'm confused about the way to handle deselecting unpaid items in the order payment confirmation module. Could you please explain this to me?`;
    
          try {
            // 填充信息并激活对话弹窗
            // window.Intercom('showNewMessage', sendMsg)
            window.Willdesk.show();
            window.Willdesk.chat(sendMsg);
          } catch (error) {
            console.info(error);
        }
      };
      
      const handleSumit = async ()=>{
        try {
            setLoading(true)
            let params = {
                dsm_record:isItemCheck?.data?.dsm_record,
                detail_id:isItemCheck?.detail?.id,
                sign:isItemCheck?.detail?.is_select ? 0 : 1,
                pop:isRemind ? 1 : 0
            };
            let res = await reqGetOrderNewShopifyDetailSelect(params);
            if (res.code === '200') {
                setListData((prev) => {
                    let list = prev.list.map((it, ind) => {
                      if (it.id === isItemCheck?.data?.id) {
                        return {
                          ...it,
                          order_items: it.order_items.map(
                            (child, inds) => {
                              if (child.id === isItemCheck?.detail?.id) {
                                child.is_select = isItemCheck?.detail?.is_select ? 1 : 0;
                              }
                              return child;
                            }
                          ),
                        };
                      }
                      return it;
                    });
                    return {
                      ...prev,
                      list,
                    };
                });
                setIsItemCheck((prev)=>({
                    ...prev,
                    open:false
                }))
                if (isItemCheck?.detail?.is_select) {
                  toastFun('Item deselected successfully')
                }else {
                  toastFun('Item selected successfully')
                }
                
                setSearchLoading(true)
                setTimeout(() => {
                    getPageData({},isItemCheck?.data.id);
                }, 1000);
            }else {
                toastFun('Set Failed')
            }
            setLoading(false)
        } catch (error) {
            
        }
      }
    return (
        <div>
            <ShopifyModal 
            id="payment-check-modal"
            heading="Confirm item deselection"
            open={isItemCheck.open}
            onClose={()=>handleOff()}
            primaryAction={{
                content:'Confirm',
                loading:loading,
                onAction:()=>{handleSumit()}
            }}
            secondaryActions={{
              content:'Cancel',
              onAction:()=>{handleOff()}
            }}
            >
                    <p>
                    You've chosen to exclude this item from your payment. Please confirm this action to proceed.
                    </p>
                    {/* <Box style={{margin:'10px 0'}}>
                        <img style={{width:'100%'}} src="/order_fulfillment/payment_check_img.png" alt="bg" />
                    </Box> */}
                    <Box>
                        <Checkbox label={`Don't remind me next time.`} checked={isRemind} onChange={(value)=>{setIsRemind(value)}}/>
                    </Box>
                <Box>
                    <Button variant='plain' onClick={()=>{handleViewDetail()}}>Unclear? Contact support.</Button>
                </Box>
            </ShopifyModal>
        </div>
    );
}

export default PaymentCheckModal;
